import { useEffect } from 'react'
import styles from './styles.module.sass'

const ResultsFilter = (props) => {
    const {
        cantResults
    } = props

    useEffect(()=>{
        if(cantResults){
            // console.log('cantResults: ', cantResults)
        }
    },[cantResults])

    return(
        cantResults >= 1
            ?
                <div className={styles?.results}>
                    { cantResults } resultados
                </div>
            : null
    )
}

export default ResultsFilter